/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropRosterMember } from './DropRosterMember';
import {
    DropRosterMemberFromJSON,
    DropRosterMemberFromJSONTyped,
    DropRosterMemberToJSON,
    DropRosterMemberToJSONTyped,
} from './DropRosterMember';
import type { RosterHighlight } from './RosterHighlight';
import {
    RosterHighlightFromJSON,
    RosterHighlightFromJSONTyped,
    RosterHighlightToJSON,
    RosterHighlightToJSONTyped,
} from './RosterHighlight';
import type { DropRosterCampaignWindow } from './DropRosterCampaignWindow';
import {
    DropRosterCampaignWindowFromJSON,
    DropRosterCampaignWindowFromJSONTyped,
    DropRosterCampaignWindowToJSON,
    DropRosterCampaignWindowToJSONTyped,
} from './DropRosterCampaignWindow';
import type { RosterCardStyle } from './RosterCardStyle';
import {
    RosterCardStyleFromJSON,
    RosterCardStyleFromJSONTyped,
    RosterCardStyleToJSON,
    RosterCardStyleToJSONTyped,
} from './RosterCardStyle';
import type { RosterFieldSpec } from './RosterFieldSpec';
import {
    RosterFieldSpecFromJSON,
    RosterFieldSpecFromJSONTyped,
    RosterFieldSpecToJSON,
    RosterFieldSpecToJSONTyped,
} from './RosterFieldSpec';

/**
 * 
 * @export
 * @interface DropRosterResponse
 */
export interface DropRosterResponse {
    /**
     * Name of the ancestor Drop this roster was inherited from. Absent when the Drop owns its roster.
     * @type {string}
     * @memberof DropRosterResponse
     */
    inheritedFromName?: string;
    /**
     * 
     * @type {string}
     * @memberof DropRosterResponse
     */
    teamName?: string;
    /**
     * 
     * @type {Array<DropRosterMember>}
     * @memberof DropRosterResponse
     */
    members: Array<DropRosterMember>;
    /**
     * Top clips of this title across the roster, best first. Populated only when no member is live — a live stream beats a clip. Empty is a normal value, not an error.
     * @type {Array<RosterHighlight>}
     * @memberof DropRosterResponse
     */
    highlights: Array<RosterHighlight>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DropRosterResponse
     */
    filterGameNames: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DropRosterResponse
     */
    filterMode: string;
    /**
     * 
     * @type {RosterCardStyle}
     * @memberof DropRosterResponse
     */
    cardStyle?: RosterCardStyle;
    /**
     * The roster card's declared extra fields — the team's authored schema with this surface's additions merged over it by key.
     * @type {Array<RosterFieldSpec>}
     * @memberof DropRosterResponse
     */
    rosterFields?: Array<RosterFieldSpec>;
    /**
     * 
     * @type {number}
     * @memberof DropRosterResponse
     */
    liveOnGame: number;
    /**
     * Members live on other titles and hidden. Surfaced so the filter is legible on the page.
     * @type {number}
     * @memberof DropRosterResponse
     */
    hiddenOffGame: number;
    /**
     * 
     * @type {number}
     * @memberof DropRosterResponse
     */
    badgedOffGame: number;
    /**
     * 
     * @type {number}
     * @memberof DropRosterResponse
     */
    total: number;
    /**
     * 
     * @type {DropRosterCampaignWindow}
     * @memberof DropRosterResponse
     */
    activeCampaignWindow?: DropRosterCampaignWindow;
    /**
     * 
     * @type {number}
     * @memberof DropRosterResponse
     */
    computedAt: number;
}



/**
 * Check if a given object implements the DropRosterResponse interface.
 */
export function instanceOfDropRosterResponse(value: object): value is DropRosterResponse {
    if (!('members' in value) || value['members'] === undefined) return false;
    if (!('highlights' in value) || value['highlights'] === undefined) return false;
    if (!('filterGameNames' in value) || value['filterGameNames'] === undefined) return false;
    if (!('filterMode' in value) || value['filterMode'] === undefined) return false;
    if (!('liveOnGame' in value) || value['liveOnGame'] === undefined) return false;
    if (!('hiddenOffGame' in value) || value['hiddenOffGame'] === undefined) return false;
    if (!('badgedOffGame' in value) || value['badgedOffGame'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropRosterResponseFromJSON(json: any): DropRosterResponse {
    return DropRosterResponseFromJSONTyped(json, false);
}

export function DropRosterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropRosterResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'inheritedFromName': json['inheritedFromName'] == null ? undefined : json['inheritedFromName'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'members': ((json['members'] as Array<any>).map(DropRosterMemberFromJSON)),
        'highlights': ((json['highlights'] as Array<any>).map(RosterHighlightFromJSON)),
        'filterGameNames': json['filterGameNames'],
        'filterMode': json['filterMode'],
        'cardStyle': json['cardStyle'] == null ? undefined : RosterCardStyleFromJSON(json['cardStyle']),
        'rosterFields': json['rosterFields'] == null ? undefined : ((json['rosterFields'] as Array<any>).map(RosterFieldSpecFromJSON)),
        'liveOnGame': json['liveOnGame'],
        'hiddenOffGame': json['hiddenOffGame'],
        'badgedOffGame': json['badgedOffGame'],
        'total': json['total'],
        'activeCampaignWindow': json['activeCampaignWindow'] == null ? undefined : DropRosterCampaignWindowFromJSON(json['activeCampaignWindow']),
        'computedAt': json['computedAt'],
    };
}

export function DropRosterResponseToJSON(json: any): DropRosterResponse {
    return DropRosterResponseToJSONTyped(json, false);
}

export function DropRosterResponseToJSONTyped(value?: DropRosterResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inheritedFromName': value['inheritedFromName'],
        'teamName': value['teamName'],
        'members': ((value['members'] as Array<any>).map(DropRosterMemberToJSON)),
        'highlights': ((value['highlights'] as Array<any>).map(RosterHighlightToJSON)),
        'filterGameNames': value['filterGameNames'],
        'filterMode': value['filterMode'],
        'cardStyle': RosterCardStyleToJSON(value['cardStyle']),
        'rosterFields': value['rosterFields'] == null ? undefined : ((value['rosterFields'] as Array<any>).map(RosterFieldSpecToJSON)),
        'liveOnGame': value['liveOnGame'],
        'hiddenOffGame': value['hiddenOffGame'],
        'badgedOffGame': value['badgedOffGame'],
        'total': value['total'],
        'activeCampaignWindow': DropRosterCampaignWindowToJSON(value['activeCampaignWindow']),
        'computedAt': value['computedAt'],
    };
}

